import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
          <img 
            src="https://static.readdy.ai/image/eaf594fcd34cc7923c4532bd1fc1545e/6ef6c3fac91f2a1905d1aec8ca485dfe.png" 
            alt="少華獎" 
            className="h-12 w-auto"
          />
        </div>

        <div className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('origin')}
            className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#F4A261] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            獎項緣起
          </button>
          <button
            onClick={() => scrollToSection('core-values')}
            className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#F4A261] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            核心理念
          </button>
          <button
            onClick={() => scrollToSection('support')}
            className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#F4A261] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            獎助內容
          </button>
          <button
            onClick={() => scrollToSection('selection')}
            className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#F4A261] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            評選機制
          </button>
          <button
            onClick={() => scrollToSection('application')}
            className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#F4A261] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            報名方式
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`px-6 py-2.5 bg-[#F4A261] text-white text-sm font-medium rounded-full hover:bg-[#E89451] transition-colors whitespace-nowrap`}
          >
            聯繫我們
          </button>
        </div>
      </div>
    </nav>
  );
}
